import DisableEditIcon from '@components/Icons/DisableEditIcon';
import Toggle from '@components/Toggle/Toggle';
import Tooltip from '@components/Tooltip/Tooltip';
import { analytics } from '@modules/analytics';
import { useCallback } from 'react';

import styles from './EditCardPopover.module.scss';

interface PreventOverrideToggleProps {
  isLocked: boolean;
  onLockToggle: () => void;
}

const PreventOverrideToggle: React.FC<React.PropsWithChildren<PreventOverrideToggleProps>> = ({
  isLocked,
  onLockToggle,
}) => {
  const handleToggle = useCallback(() => {
    analytics.track({
      name: 'preventoverridebutton_clicked',
      properties: { module: 'card_designer' },
    });
    onLockToggle();
  }, [onLockToggle]);

  return (
    <div className={styles['controls-section-lock-container']}>
      <div className={styles['controls-section-lock']}>
        {/* biome-ignore lint/correctness/useUniqueElementIds: historic */}
        <div className={styles['controls-section-lock-label']} id="controls-section-lock-label">
          <Tooltip label="If enabled, the card owner will not be able to edit this field" aria-label="">
            <span>
              <span className={styles['controls-section-lock-label-icon']}>
                <DisableEditIcon />
              </span>
              <span>Prevent override</span>
            </span>
          </Tooltip>
        </div>
        <Toggle state={isLocked} onChange={handleToggle} />
      </div>
    </div>
  );
};

export default PreventOverrideToggle;
